module.exports = __webpack_public_path__ + "static/media/booth2_btn.ea5c43a5.png";